import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "form-group col-12 col-md-6" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = { class: "form-group col-12 col-md-6" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Výběr od", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "input-group-text rounded-0 fs-14 text-muted" }, [
            _createElementVNode("i", { class: "flaticon-calendar lh-1 position-relative top-1" })
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.borderDates.startDate) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setCustomDateSelection && _ctx.setCustomDateSelection(...args))),
            type: "date",
            class: "form-control shadow-none rounded-0 text-black me-1"
          }, null, 544), [
            [_vModelText, _ctx.borderDates.startDate]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Výběr do", -1)),
        _createElementVNode("div", _hoisted_6, [
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "input-group-text rounded-0 fs-14 text-muted" }, [
            _createElementVNode("i", { class: "flaticon-calendar lh-1 position-relative top-1" })
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.borderDates.endDate) = $event)),
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setCustomDateSelection && _ctx.setCustomDateSelection(...args))),
            type: "date",
            class: "form-control shadow-none rounded-0 text-black me-1"
          }, null, 544), [
            [_vModelText, _ctx.borderDates.endDate]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Časové období:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.timeSelected) = $event)),
        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeBorderDates(_ctx.timeSelected))),
        class: "form-select shadow-none fw-semibold rounded-0 col-6"
      }, [...(_cache[10] || (_cache[10] = [
        _createStaticVNode("<option value=\"day\">Dnes</option><option value=\"week\">Týden</option><option value=\"month\">Měsíc</option><option value=\"30days\">30 dní</option><option value=\"60days\">60 dní</option><option value=\"90days\">90 dní</option><option value=\"120days\">120 dní</option><option value=\"custom\">Vlastní</option>", 8)
      ]))], 544), [
        [_vModelSelect, _ctx.timeSelected]
      ])
    ])
  ]))
}